import api from './api'
import { Employee, PaginatedResponse, ApiResponse, WorkCenterType } from '../types'

export interface EmployeeFilters {
  workCenterId?: string
  workCenterType?: WorkCenterType
  shiftId?: string
  positionId?: string
  hasStop?: boolean
  isActive?: boolean
  search?: string
  page?: number
  limit?: number
}

export interface CreateEmployeeData {
  employeeId: string
  dni: string
  firstName: string
  lastName: string
  email?: string
  positionId: string
  shiftId: string  // UUID del turno
  workCenterId: string
  hasStop?: boolean
  daysAt5Shifts?: number
  startDate: string
  isPresecadoCelulosa?: boolean
  exemptFromLimits?: boolean
  contractType?: string
  isCloseToRetirement?: boolean
  canRequestPP5R?: boolean
  password?: string
}

export interface UpdateEmployeeData {
  dni?: string
  firstName?: string
  lastName?: string
  email?: string | null
  positionId?: string
  shiftId?: string
  workCenterId?: string
  hasStop?: boolean
  daysAt5Shifts?: number
  startDate?: string
  isActive?: boolean
  isPresecadoCelulosa?: boolean
  exemptFromLimits?: boolean
  contractType?: string
  isCloseToRetirement?: boolean
  canRequestPP5R?: boolean
  daysUsedPP5R?: number
  password?: string
  userIsActive?: boolean
}

export const employeeService = {
  async getAll(filters?: EmployeeFilters): Promise<PaginatedResponse<Employee>> {
    const params = new URLSearchParams()
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          params.append(key, String(value))
        }
      })
    }
    const response = await api.get<PaginatedResponse<Employee>>(
      `/employees?${params.toString()}`
    )
    return response.data
  },

  async getById(id: string): Promise<Employee> {
    const response = await api.get<ApiResponse<Employee>>(`/employees/${id}`)
    return response.data.data
  },

  async getByEmployeeId(employeeId: string): Promise<Employee> {
    const response = await api.get<ApiResponse<Employee>>(
      `/employees/by-employee-id/${employeeId}`
    )
    return response.data.data
  },

  async create(data: CreateEmployeeData): Promise<Employee> {
    const response = await api.post<ApiResponse<Employee>>('/employees', data)
    return response.data.data
  },

  async update(id: string, data: UpdateEmployeeData): Promise<Employee> {
    const response = await api.put<ApiResponse<Employee>>(`/employees/${id}`, data)
    return response.data.data
  },

  async toggleActive(id: string): Promise<Employee> {
    const response = await api.patch<ApiResponse<Employee>>(`/employees/${id}/toggle`)
    return response.data.data
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/employees/${id}`)
  },

  async getStats(): Promise<{
    total: number
    byWorkCenter: Record<string, number>
    byShift: Record<string, number>
    active: number
    inactive: number
  }> {
    const response = await api.get('/employees/stats')
    return response.data.data
  },
}
